import { Component, OnInit, Inject, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, MatDialog, getMatFormFieldDuplicatedHintError } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service';
import { ServerService } from '../../../services/server.service';
import { DatePipe } from '@angular/common';
import { ClipBoardService as messageService } from 'src/app/services/clipboard.service';

@Component({
  selector: 'app-amount-spent-bulk-entry',
  templateUrl: './amount-spent-bulk-entry.component.html',
  styleUrls: ['./amount-spent-bulk-entry.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe]
})
export class AmountSpentBulkEntryComponent implements OnInit {

  authToken = localStorage.getItem("token");

  showComponentLoader: boolean = false;

  btnStatus: boolean = false

  isSubmit:boolean=false;

  addForm: FormGroup;

  currentDate: any = new Date();
  yesturdayRowDate: any;
  yesturdayDate: any;

  marketingJobList: any;

  filterBody: any;

  showDeleteConfirm: boolean = false;
  deleteRecordData: any;
  dataIndex: any;

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<AmountSpentBulkEntryComponent>,
    private clipBoardMessageService: messageService,
    @Inject(MAT_DIALOG_DATA) public data) {

    this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');

    this.yesturdayRowDate = new Date(this.currentDate);
    this.yesturdayRowDate.setDate(this.yesturdayRowDate.getDate() - 1);
    this.yesturdayDate = this.datePipe.transform(this.yesturdayRowDate, 'yyyy-MM-dd');

    this.filterBody = data;
  }

  ngOnInit() {
    this.setDeliveryForm()
    this.allMarketingJob()
  }

  allMarketingJob() {

    // this.pageIndex = 0;
    // this.pageSize = 50;

    this.showComponentLoader = true;

    //let url = "campaign_module/marketing_jobs/master_list?per_page=" + this.pageSize + "&page=" + this.pageIndex;
    let url = "campaign_module/marketing_jobs/master_list";

    this.serverService.campaignListByFilter(url, this.filterBody, this.authToken).subscribe(data => {
      //console.log(data)
      //this.marketingJobList = data.marketing_jobs;

      this.marketingJobList = data.marketing_jobs.filter(item => item.marketing_manager.length > 0);

      this.marketingJobList.forEach(item => {

        // const formGroup = this.fb.group({
        //   campaignId: [item.campaign_id],
        //   date: [this.yesturdayDate],
        //   marketingManager: [],  
        //   leadsDelivered: [item.aggregated_data.total_leads_delivered],    
        //   platformType: [item.platform],
        //   adType: []
        // });

        // this.arrAddDeliveryForm.push(formGroup);

        if (item.platform == 'Meta') {
          item['addType'] = ['Lead Generation', 'Branding', 'Engagement', 'Video Views', 'Traffic', 'Other']
        }

        if (item.platform == "Google") {
          item['addType'] = ["Display", "Discovery", "Search", "Video", "Performance Max", "Smart Campaign", "App Promotion", "Shopping", "Other"]
        }

        if (item.platform == "Taboola") {
          item['addType'] = ["Taboola", "Other"]
        }

        if (item.platform == "LinkedIn" || item.platform == "Linkedin") {
          item['addType'] = ["Engagement", "Video Views", "Lead Generation", "Branding", "Traffic", "Talent Leads", "Messaging", "Job Applicants", "Other"]
        }

        if (item.platform == "Quora") {
          item['addType'] = ["Website Conversion", "Other"]
        }

        if (item.platform == "Stack Overflow") {
          item['addType'] = ["Website Conversion", "Other"]
        }

        if (item.platform == "LMS") {
          item['addType'] = ["LMS"]
        }

        if (item.platform == "" || item.platform == null || item.platform == undefined) {
          item['addType'] = []
        }

        const formGroup = this.fb.group({
          campaign_id: [item.campaign_id],
          marketing_job_id: [item.id],
          recorded_date: [this.yesturdayDate],
          marketing_manager_id: [item.marketing_manager.length ? item.marketing_manager[0].id : null],
          //leads_generated: [item.aggregated_data.total_leads_generated],
          leads_generated: [null],
          amount: [null],
          clicks: [null],
          impressions: [null],
          platform: [item.platform],
          //ad_type: [item.addType.length?item.addType[0]:null]
          ad_type: [null]
        });

        this.arrAddDeliveryForm.push(formGroup);

      });

      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  setDeliveryForm() {
    this.addForm = this.fb.group({
      addInnerForm: this.fb.array([])
    })
  }

  setAddDeliveryForm() {
    return this.fb.group({
      campaign_id: [],
      marketing_job_id: [],
      recorded_date: [],
      marketing_manager_id: [],
      leads_generated: [, Validators.compose([Validators.required])],
      amount: [, Validators.compose([Validators.required])],
      clicks: [],
      impressions: [],
      platform: [],
      ad_type: []
    })
  }

  get arrAddDeliveryForm(): FormArray {
    return this.addForm.get("addInnerForm") as FormArray;
  }

  addRow() {
    this.arrAddDeliveryForm.push(this.setAddDeliveryForm());
  }

  removeRow(record:any, i) {
    this.showDeleteConfirm = true;
    this.deleteRecordData = record;
    this.dataIndex = i;
  }

  noDeleteRecord() {
    this.showDeleteConfirm = false;
  }

  deleteRecord(i) {
    if (this.arrAddDeliveryForm.length > 1) {
      this.arrAddDeliveryForm.removeAt(i);
      this.marketingJobList.splice(i, 1);
      this.showDeleteConfirm = false;
    }
  }

  saveDeliveryForm() {

    this.btnStatus = true;
    this.isSubmit = true;

    if (this.addForm.invalid) {
      return false;
    }

    const filterData = this.addForm.value.addInnerForm.map(item => {

      if (!item.ad_type) {
        delete item.ad_type;
      }

      if (!item.leads_generated) {
        delete item.leads_generated;
      }

      if (!item.amount) {
        delete item.amount;
      }

      if (!item.clicks) {
        delete item.clicks;
      }

      if (!item.impressions) {
        delete item.impressions;
      }

      return item;
    });

    let body = {
      records: filterData
    }

    // console.log(body)
    // return false;

    this.serverService.saveDeliveryForm('campaign_module/campaign/add_spent', body, this.authToken).subscribe(data => {
      this.clipBoardMessageService.showMessgeInText("Amount Added Successfully", "success-snackbar")
      this.btnStatus = false
      this.isSubmit = false
      this.showComponentLoader = false
      this.dialogRef.close(data)
    },
      err => {
        this.btnStatus = false
        this.isSubmit = false
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
        // this.snackBar.open(JSON.parse(err._body).errors[0].errors, '', {
        //   duration: 3000,
        //   verticalPosition: 'top',
        //   horizontalPosition: 'end',
        //   panelClass: ['error-snackbar']
        // })
      }
    )
  }

  close() {
    this.dialogRef.close();
  }

}
